import React, { useEffect } from "react";
import "./App.css";
import { AppContent } from "./AppContent";
import { BrowserRouter } from "react-router-dom";
import packageJson from "../package.json";

function App() {
  const CURRENT_VERSION = packageJson.version || "1.0.0";

  const isLocal =
    window.location.hostname === "localhost" && window.location.port === "3000";

  useEffect(() => {
    const urlLang = new URLSearchParams(window.location.search).get("lang");
    if (urlLang) {
      console.log("urlLangParam", urlLang);
      sessionStorage.setItem("lang", urlLang);
    }
  }, []);

  useEffect(() => {
    if (!isLocal) {
      fetch("/version.json", { cache: "no-cache" })
      .then((res) => res.json())
      .then((data) => {
        console.log("overcheck", data.version, CURRENT_VERSION);
          if (data.version !== CURRENT_VERSION) {
            console.log("check", data.version, CURRENT_VERSION);
            window.location.reload();
          }
        });
    }
  }, []);

  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}
export default App;
